import { createElement } from 'react';
import { node, string, bool } from 'prop-types';
import { placementPropType, animatePropTypes, restrictHidePropTypes, animateDefaultProps, restrictDefaultProps } from './types/props.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import OverlayContainer from './Overlay/OverlayContainer.js';
import _Overlay from './Overlay/styled.js';
import OverlayHide from './Overlay/OverlayHide.js';
import OverlayShow from './Overlay/OverlayShow.js';
import OverlayToggle from './Overlay/OverlayToggle.js';

var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "isVisible"]);

  return createElement(_Overlay, _extends({
    visible: isVisible
  }, props), children);
};
Overlay.Container = OverlayContainer;
Overlay.Hide = OverlayHide;
Overlay.Show = OverlayShow;
Overlay.Toggle = OverlayToggle;
var overlayPropTypes = _objectSpread({
  children: node.isRequired,
  className: string,
  isVisible: bool,
  placement: placementPropType
}, animatePropTypes, restrictHidePropTypes);
Overlay.propTypes = overlayPropTypes;
var overlayDefaultProps = _objectSpread({
  className: undefined,
  isVisible: false,
  placement: undefined
}, animateDefaultProps, restrictDefaultProps, {
  hideOnEsc: true
});
Overlay.defaultProps = overlayDefaultProps;
var C = Overlay;

export { C as a, overlayPropTypes as b, overlayDefaultProps as c };
